import {
  Box,
  Button,
  Checkbox,
  Flex,
  Heading,
  Radio,
  RadioGroup,
  Stack,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Fragment, useState } from "react";
import * as React from "react";
import { SUPPLIER_QUESTIONNAIRE_CATEGORIES } from "../../helpers";

function SelectCategory({ handleSetCategory }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierQuestionnaire.selectCategory"
  });

  const containerProps = useBreakpointValue({
    base: {
      flexDirection: "column",
      alignItems: "start"
    },
    xl: {
      flexDirection: "row",
      alignItems: "end"
    }
  });

  const [haveReadDefs, setHaveReadDefs] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleReadDefinitionsChanged = (isChecked) => {
    setHaveReadDefs(isChecked);
    if (!isChecked) {
      setSelectedCategory(null);
    }
  };

  return (
    <Fragment>
      <Flex
        flexDirection={containerProps.flexDirection}
        alignItems={containerProps.alignItems}
        justifyContent="space-between"
        paddingInlineStart={10}
        paddingBlockStart={5}
        gap={5}
      >
        <Box width="80%">
          <Heading size="md" marginBottom={6}>{t("header")}</Heading>
          <Heading size="sm">{t("product")}:</Heading>
          <Text marginBottom={3}>{t("productDefinition")}</Text>
          <Heading size="sm">{t("revenue")}:</Heading>
          <Text marginBottom={3}>{t("revenueDefinition")}</Text>
          <Heading size="sm">{t("location")}:</Heading>
          <Text marginBottom={6}>{t("locationDefinition")}</Text>
          <Heading size="sm" marginBottom={3}>{t("noneApplicable")}</Heading>
          <Checkbox
            colorScheme={"customScheme"}
            isChecked={haveReadDefs}
            color="primary"
            marginBlockStart={1}
            onChange={(e) => handleReadDefinitionsChanged(e.target.checked)}
            marginBottom={haveReadDefs ? 6 : 0}
          >
            {t("haveReadDefinitions")}
          </Checkbox>
          <Box>
            {haveReadDefs &&
              <Box border={"1px solid black"} padding={2} position="relative">
                <Text marginBottom={2}>{t("basedOnInfo")}</Text>
                <RadioGroup value={selectedCategory}>
                  <Stack spacing={1} direction="column">
                    <Radio
                      colorScheme="customScheme"
                      value={SUPPLIER_QUESTIONNAIRE_CATEGORIES.PRODUCT}
                      onChange={e => {
                        setSelectedCategory(e?.target.value);
                      }}
                    >
                      {t("product")}
                    </Radio>
                    <Radio
                      colorScheme="customScheme"
                      value={SUPPLIER_QUESTIONNAIRE_CATEGORIES.REVENUE}
                      onChange={e => {
                        setSelectedCategory(e?.target.value);
                      }}
                    >
                      {t("revenue")}
                    </Radio>
                    <Radio
                      colorScheme="customScheme"
                      value={SUPPLIER_QUESTIONNAIRE_CATEGORIES.LOCATION}
                      onChange={e => {
                        setSelectedCategory(e?.target.value);
                      }}
                    >
                      {t("location")}
                    </Radio>
                  </Stack>
                </RadioGroup>
              </Box>
            }
          </Box>
        </Box>
        {haveReadDefs && selectedCategory !== null &&
          <Button
            colorScheme="white"
            color="esg_lightgreen"
            border={"1px solid"}
            borderColor={"esg_lightgreen"}
            type="submit"
            width="32"
            onClick={() => handleSetCategory(selectedCategory)}
          >
            {t("next")}
          </Button>}
      </Flex>
    </Fragment>
  );
}

export default SelectCategory;